import { _sharedActionsConstantsSearch } from "./actions";

const initSearchFilter = {
  searchedQuery: undefined,
  translate: [],
  detect: [],
  autocomplete: [],
  suggestions: [],
  corrections: [],
  shortcuts: [],
  synonyms: [],
};


export const _sharedStateSearch = {
  shortcuts: {},
  searchFilter: initSearchFilter,

  searchQueryLangs: {},
  searchQueryLangsCache: {},

  queryCorrectionsCache: {},
};

export const _sharedReducerSearch = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsSearch.FETCH_SHORTCUT_SUCCESS:
      return { ...state, shortcuts: action.data };
    case _sharedActionsConstantsSearch.FETCH_DETECT_SUCCESS: {
      const { detect, } = action.data;
      const newSearchFilter = { ...state.searchFilter };
      newSearchFilter.detect = detect || [];
      return { ...state, searchFilter: newSearchFilter };
    }
    case _sharedActionsConstantsSearch.FETCH_LANGS_FOR_WORD_SUCCESS: {
      const { langs, query, correction } = action.data;

      const searchQueryLangsCache = { ...state.searchQueryLangsCache };
      searchQueryLangsCache[query] = langs;

      const newQueryCorrections = { ...state.queryCorrectionsCache };
      if (correction) {
        newQueryCorrections[query] = correction;
      }

      return {
        ...state,
        searchQueryLangs: langs,
        searchQueryLangsCache,
        queryCorrectionsCache: newQueryCorrections,
      };
    }

    case _sharedActionsConstantsSearch.FETCH_SUGGESTION_SUCCESS: {
      let searchedQuery,
        suggestions,
        corrections,
        shortcuts,
        synonyms,
        autocomplete;

      if (action.data) {
        searchedQuery = action.data.searchedQuery;
        suggestions = action.data.suggestions;
        corrections = action.data.corrections;
        shortcuts = action.data.shortcuts;
        synonyms = action.data.synonyms;
        autocomplete = action.data.autocomplete;
      }

      const searchFilterNew = { ...state.searchFilter };

      if (!searchedQuery) {
        searchFilterNew.detect = initSearchFilter.detect;
        searchFilterNew.translate = initSearchFilter.translate;
      }

      searchFilterNew.searchedQuery = searchedQuery || "";
      searchFilterNew.suggestions = suggestions || initSearchFilter.suggestions;
      searchFilterNew.corrections = corrections || initSearchFilter.corrections;
      searchFilterNew.shortcuts = shortcuts || initSearchFilter.shortcuts;
      searchFilterNew.synonyms = synonyms || initSearchFilter.synonyms;
      searchFilterNew.autocomplete = autocomplete || initSearchFilter.autocomplete;

      return { ...state, searchFilter: searchFilterNew };
    }

    default:
      return state;
  }
};
